import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { CategoriaArquivoService } from '../../../shared/services/apis/integracao-arquivos/categoria-arquivo.service';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { ListaCategoriaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-categoria-arquivo.response';
import { ArquivoService } from '../../../shared/services/apis/integracao-arquivos/arquivo.service';
import { ListaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-arquivo.response';
import { ArquivoStruct } from '../../../shared/services/structs/integracao-arquivos/arquivo.struct';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-arquivo-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    TemPermissaoDirective,
  ],
  templateUrl: './arquivo-lista.component.html',
  styleUrl: './arquivo-lista.component.css',
})
export class ArquivoListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private categoriaArquivoService: CategoriaArquivoService,
    private arquivoService: ArquivoService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_Arquivo;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaArquivoResponse: ListaArquivoResponse | undefined;
  public _categoriaLookupResponse: ListaCategoriaArquivoResponse;
  public displayedColumns: string[] = [
    'nomeArquivo',
    'versaoArquivo',
    'categoriaArquivo',
    'tagArquivo',
    'dataAlteracao',
    'action-delete',
  ];
  public _dataSource = new MatTableDataSource<ArquivoStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      arquivo: [''],
      versao: [''],
      listaCategoriaArquivo: [''],
    });

    this.popularLookup();
    this.pesquisar();
  }

  pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const nome: string = this.model.get('arquivo')?.value || null;
    const versao: string = this.model.get('versao')?.value || null;
    const idCategoriaArquivo: number = this.model.get('listaCategoriaArquivo')?.value || null;

    this.arquivoService.obterListaArquivo(nome, versao, idCategoriaArquivo, this._paginaAtual).subscribe({
      next: (listaArquivoResponse: ListaArquivoResponse) => {
        if (listaArquivoResponse.isError) {
          this.alertService.show('Erro', listaArquivoResponse.errorDescription, AlertType.error);
          return;
        }

        this._isLoading = false;
        this._ultimaPagina = true;

        if (!this._listaArquivoResponse) {
          this._listaArquivoResponse = listaArquivoResponse;
          this._ultimaPagina = false;
        }

        this._dataSource.data = this._listaArquivoResponse.listaArquivo;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaArquivoResponse = undefined;
    this.pesquisar();
  }

  abrirModalExcluir(idArquivo: number, nomeArquivo: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir o arquivo ${nomeArquivo}? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.excluir(idArquivo);
        }
      },
    });
  }

  private excluir(idArquivo: number): void {
    this.arquivoService.excluir(idArquivo).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Item excluido com sucesso', AlertType.success);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  popularLookup(): void {
    this.categoriaArquivoService.lookup().subscribe({
      next: (listaCategoriaArquivoResponse: ListaCategoriaArquivoResponse) => {
        if (listaCategoriaArquivoResponse.isError) {
          this.alertService.show('Erro', listaCategoriaArquivoResponse.errorDescription, AlertType.error);
          return;
        }

        this._categoriaLookupResponse = listaCategoriaArquivoResponse;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  async popularDadosListaCategoriaArquivo(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.categoriaArquivoService.lookup().subscribe({
        next: (listaCategoriaArquivoResponse: ListaCategoriaArquivoResponse) => {
          if (listaCategoriaArquivoResponse.isError) {
            this.alertService.show('Erro', listaCategoriaArquivoResponse.errorDescription, AlertType.error);
            return;
          }

          this._categoriaLookupResponse = listaCategoriaArquivoResponse;
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error.message, AlertType.error);
          reject();
        },
      });
    });
  }

  public async habilitaSelecaoCategoria(): Promise<void> {
    await this.popularDadosListaCategoriaArquivo();

    this.model.get('listaCategoriaArquivo')?.enable();
  }
}
